import { createSelector } from 'reselect';

import { SelectedCoworkingType } from 'shared/enums/SelectedCoworkingType';

import { getCoworkingFixedWorkplaceSelector } from '../dump/getCoworkingFixedWorkplaceSelector';
import { getCoworkingFlexWorkplaceSelector } from '../dump/getCoworkingFlexWorkplaceSelector';

import { selectedCoworkingTypeSelector } from './selectedCoworkingTypeSelector';
import { separateOfficeSelector } from './separateOfficeSelector';

export const coworkingSelectedOfferSelector = createSelector(
  [
    selectedCoworkingTypeSelector,
    separateOfficeSelector,
    getCoworkingFixedWorkplaceSelector,
    getCoworkingFlexWorkplaceSelector,
  ],
  (selectedCoworkingType, offer, fixedWorkplace, flexibleWorkplace) => {
    switch (selectedCoworkingType) {
      case SelectedCoworkingType.FixedWorkplace:
        return fixedWorkplace;

      case SelectedCoworkingType.FlexibleWorkplace:
        return flexibleWorkplace;

      case SelectedCoworkingType.SeparateOffice:
        return offer;

      case SelectedCoworkingType.None:
      default:
        return null;
    }
  },
);
